import { CloseCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import HeaderSecondary from 'components/Header/headerSecondary';
import useTranslation from 'customHooks/translate';

const PaymentFailed = () => {
  const navigate = useNavigate();
  const translation = useTranslation();

  return (
    <section className="box-border flex min-h-screen flex-col gap-[48px] overflow-hidden px-[24px] py-[24px] md:px-[48px] xl:px-[156px]">
      <HeaderSecondary />

      <div className="flex flex-1 flex-col items-center gap-[24px] text-center">
        <CloseCircleOutlined className="text-[72px] text-red-500 md:text-[96px]" />

        <div className="flex max-w-[520px] flex-col gap-[12px]">
          <h1 className="text-[28px] font-bold text-[#1D1D1D] md:text-[36px]">
            {translation.paymentResult.failedTitle}
          </h1>
          <p className="text-[16px] text-[rgba(41,45,50,0.7)] md:text-[18px]">
            {translation.paymentResult.failedDescription}
          </p>
        </div>

        <div className="mt-[8px] flex flex-col gap-[12px] sm:flex-row">
          <button
            type="button"
            onClick={() => navigate('/profile/payment')}
            className="rounded-[8px] bg-green-600 px-[24px] py-[12px] text-[14px] font-semibold text-white transition-all hover:bg-green-700"
          >
            {translation.paymentResult.tryAgain}
          </button>
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="rounded-[8px] border border-[rgba(41,45,50,0.2)] bg-white px-[24px] py-[12px] text-[14px] font-semibold text-[#1D1D1D] transition-all hover:border-[rgba(41,45,50,0.35)]"
          >
            {translation.paymentResult.goToDashboard}
          </button>
        </div>
      </div>
    </section>
  );
};

export default PaymentFailed;
